import { render, staticRenderFns } from "./Stream.vue?vue&type=template&id=2178f52a&scoped=true&"
import script from "./Stream.vue?vue&type=script&lang=js&"
export * from "./Stream.vue?vue&type=script&lang=js&"
import style0 from "./Stream.vue?vue&type=style&index=0&id=2178f52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178f52a",
  null
  
)

export default component.exports